import React, { useEffect, useState } from "react";
import srcAgBaseLogo from "./agbase-logo.png";

export const LoginLayout = ({ children }: any) => {
  return (
    <div className="w-full flex flex-col md:flex-row h-full">
      <div className="w-full md:w-1/2 py-12 sm:px-20 px-8">
        <img src={srcAgBaseLogo} className="max-w-28" />
        <div className="flex max-w-lg">{children}</div>
      </div>
      <div className="md:w-1/2 hidden md:flex w-full h-[100vh] p-6">
        <img
          src={"intro.png"}
          alt="right side"
          className="h-full w-full object-cover rounded-[20px]"
        />
      </div>
    </div>
  );
};
